export const PUBLISH_UNSUPPORTED = 'Publishing isn’t supported for this channel'

export function isPublishSupported(channel: {
  products?: readonly string[] | null
}): boolean {
  return channel.products?.includes('publish') ?? true
}
